var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tap-top",style:([_vm.display ? {'display':'block'} : { 'display':'none'} ])},[_c('feather',{attrs:{"type":"chevrons-up"},on:{"click":function($event){return _vm.executeScroll()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }